import type { CreateIncomingEvent, IncomingEvent } from '../outgoing-webhooks/incoming-event.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class IncomingEventFactory extends ObjectFactory<IncomingEvent> {
  protected getDefaults(): IncomingEvent {
    return {
      ...baseDocumentFactory.build(),
      correlationId: 'correlation-id',
      event: 'on-site-created',
      identifiers: { tenantId: 'aaaa00001111bbbb2222cccc' },
      payload: {},
    };
  }

  /** Build a CreateIncomingEvent body (no base document fields). */
  buildCreate(overrides: Partial<CreateIncomingEvent> = {}): CreateIncomingEvent {
    return {
      correlationId: 'correlation-id',
      event: 'on-site-created',
      identifiers: { tenantId: 'aaaa00001111bbbb2222cccc' },
      payload: {},
      ...overrides,
    };
  }
}

export const incomingEventFactory = new IncomingEventFactory();
